import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';

const postUserLead = async (payload) => {
  const url = `${apiConfig('strapi')}/api/user-leads`
  const { response, error }: any = await postMethod({ endPoint: url,body:payload });
  if (response) {
    return response?.data?.attributes;
  } else return null;
};
export default postUserLead;
